// Thin wrapper around react-apexcharts so the chart options live in ONE place.
// All callers pass: { title, categories, series, color }.
const React = require('react');
const { createElement: h } = React;
const Chart = require('react-apexcharts').default;

function formatBucketLabel(iso, bucket) {
  var d = new Date(iso);
  if (!Number.isFinite(d.getTime())) return iso;
  if (bucket === 'hour')  return d.getHours() + ':00';
  if (bucket === 'day')   return (d.getMonth() + 1) + '/' + d.getDate();
  if (bucket === 'week')  return 'uge ' + (d.getMonth() + 1) + '/' + d.getDate();
  if (bucket === 'month') return d.toLocaleString('da-DK', { month: 'short', year: '2-digit' });
  return iso;
}

function buildOptions(categories, color) {
  return {
    chart: {
      type: 'bar',
      toolbar: { show: false },
      animations: { enabled: true, speed: 250 },
      fontFamily: 'inherit'
    },
    plotOptions: {
      bar: { borderRadius: 4, columnWidth: '70%' }
    },
    dataLabels: { enabled: false },
    colors: [color || '#a67c52'],
    grid: {
      borderColor: '#eef0f3',
      strokeDashArray: 3,
      padding: { left: 10, right: 10, bottom: 0 },
      yaxis: { lines: { show: true } },
      xaxis: { lines: { show: false } }
    },
    xaxis: {
      categories: categories,
      labels: { show: false },
      axisBorder: { show: false },
      axisTicks: { show: false }
    },
    yaxis: {
      labels: {
        style: { colors: '#64748b', fontSize: '11px' },
        formatter: function(v) {
          if (v >= 1000000) return (v / 1000000).toFixed(1) + 'M';
          if (v >= 1000)    return (v / 1000).toFixed(1) + 'K';
          return Math.round(v);
        }
      },
      forceNiceScale: true,
      min: 0
    },
    tooltip: {
      theme: 'light',
      x: { show: true },
      y: { formatter: function(v) { return Math.round(v).toLocaleString('da-DK'); } }
    }
  };
}

function UsageChart(props) {
  var bucket = props.bucket || 'day';
  var points = Array.isArray(props.points) ? props.points : [];
  var categories = points.map(function(p) { return formatBucketLabel(p.bucket, bucket); });
  var data = points.map(function(p) { return p[props.dataKey] || 0; });
  var series = [{ name: props.title || '', data: data }];
  var options = buildOptions(categories, props.color);

  return h('div', { className: 'usp-chart' },
    h('div', { className: 'usp-chart__header' },
      h('h3', { className: 'usp-chart__title' }, props.title || ''),
      props.subtitle ? h('span', { className: 'usp-chart__subtitle' }, props.subtitle) : null
    ),
    h(Chart, { options: options, series: series, type: 'bar', height: 220 })
  );
}

module.exports = UsageChart;
